import { useContext } from "react";
import { LoggerContext } from "../contexts/LoggerContext";
/**
 * Hook to get loggers from context
 */ export function useLoggers() {
    const loggers = useContext(LoggerContext);
    if (!loggers) {
        throw new Error("useLoggers must be used within a LoggerContextProvider");
    }
    return loggers;
}
